import React, { ReactNode } from 'react'
import { IDataDisplayerItemField } from './DataDisplayer'
import { Link } from 'react-router-dom'
import { Avatar, Skeleton } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import DataDisplayerItemField from './DataDisplayerItemField'
import Thumbnail from '../Thumbnail'

export interface ICardItem{
    id: number,
    fields: IDataDisplayerItemField[],
    thumbnail: string,
    rawItem: { [key: string]: any },
    link?: string,
    loading?: boolean,
    onClick?: (data: { [key: string]: any }) => void
}

interface IBaseCardItemWrapperProps {
    item: ICardItem,
    children: ReactNode
}

const BaseCardItemWrapper: React.FC<IBaseCardItemWrapperProps> = ({ children, ...props }) => {

    const { link, onClick, rawItem } = props.item

    if (onClick){
        return(
            <div className="single-card-item-wrapper" onClick={() => onClick(rawItem)}>
                {children}
            </div>
        )
    }

    if (link){
        return(
            <div className="single-card-item-wrapper">
                <Link to={link}>
                    {children}
                </Link>
            </div>
        )
    }

    return(
        <div className="single-card-item-wrapper">
            {children}
        </div>
    )
}

const CardItem: React.FC<ICardItem> = (props) => {

    const { id, fields, rawItem, thumbnail, loading } = props

    if (loading){
        return(
            <BaseCardItemWrapper item={props}>
                <div className="single-card-item-box">
                    <div className="content-of-single-card-item-box">

                        <div className="thumbnail-box-of-single-card-item-box">
                            <div className="content-of-thumbnail-box-of-single-card-item-box">
                                <Skeleton variant="rectangular" width="100%" height="auto" />
                            </div>
                        </div>

                        <div className="fields-of-single-card-item-box">
                            <div className="content-of-fields-of-single-card-item-box">

                                <Skeleton variant="text" width={100} style={{ marginBottom: 15 }} />
                                <Skeleton variant="text" width={150} style={{ marginBottom: 15 }} />
                                <Skeleton variant="text" width={170} style={{ marginBottom: 15 }} />

                            </div>
                        </div>

                    </div>
                </div>
            </BaseCardItemWrapper>
        )
    }

    return(
        <BaseCardItemWrapper item={props}>
            <div className="single-card-item-box">
                <div className="content-of-single-card-item-box">

                    <div className="thumbnail-box-of-single-card-item-box">
                        <div className="content-of-thumbnail-box-of-single-card-item-box">
                            <Thumbnail src={thumbnail} />
                            {/* <Avatar src={thumbnail}><GenerateIcon icon="image" /></Avatar> */}
                        </div>
                    </div>

                    <div className="fields-of-single-card-item-box">
                        <div className="content-of-fields-of-single-card-item-box">
                            {fields.map((field: IDataDisplayerItemField, index: number) => <DataDisplayerItemField rawItem={rawItem} hideColumns={[]} {...field} key={index} />)}
                        </div>
                    </div>

                    <div className="action-buttons-of-single-card-item-box">
                        <div className="content-of-action-buttons-of-single-card-item-box">

                        </div>
                    </div>

                </div>
            </div>
        </BaseCardItemWrapper>
    )
}

export default CardItem